import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  handleListResponse,
  seo,
  ValidateExtensionCsv,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import { addBulkCsvUpload, downloadCSVFIle } from "reduxStore/action/visitorActions";

const UploadCsv = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [apiResponse, setApiResponse] = useState([]);
  const propertySelector = useSelector((state) => state.propertyData);

  const addBulkCSVUploadSelector =
    useSelector((state) => state.visitor) || [];

  useEffect(() => {
    if (addBulkCSVUploadSelector.create === true) {
      if (addBulkCSVUploadSelector?.response?.status === 200) {
        setForm({});
        navigatpage("/visitor");
      }
    }
  }, [addBulkCSVUploadSelector]);

  useEffect(() => {
    if (propertySelector.response) {
      const { response } = propertySelector;
      if (response?.status === 200) {
        setApiResponse(handleListResponse(response.data));
      } else {
        setApiResponse([]);
      }
    }
  }, [propertySelector]);

  useEffect(() => {
    dispatch(getAgentProperty());
  }, []);

  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionCsv(e.target);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        ...form,
        preview: preview,
        raw: image,
      };
      setForm(nextFormState);
    }
  };

  const handleUpdate = () => {
    if (!handleValid()) {
      const formData = new FormData();
      form.property_id && formData.append("property_id", form.property_id);
      if (form.raw) {
        formData.append("visitorFile", form.raw);
      }
      dispatch(addBulkCsvUpload(formData));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.property_id) {
      formError = true;
      err["property_id"] = strings.propertynameErr;
    }
    if (!form?.preview) {
      formError = true;
      err["validMedia"] = strings.csvFile;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Bulk Upload",
      metaDescription: "Bulk upload",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.bulkUpload}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={strings.bulkUpload}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.bulkUpload}</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.selectProperty}<span className="required-field"></span>
                      </label>
                      <select
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="property_id"
                        value={form.property_id}
                        onChange={(e) => {
                          var index = e.nativeEvent.target.selectedIndex;
                          var property_title = e.nativeEvent.target[index].text;
                          const nextFormState = {
                            ...form,
                            property_id: e.target.value,
                            property_title: property_title,
                          };
                          setForm(nextFormState);
                        }}
                      >
                        <option value="">
                          {strings.selectProp}
                        </option>
                        {apiResponse &&
                          apiResponse.map((item, index) => (
                            <option key={index} value={item.property_id}>
                              {item.property_title}
                            </option>
                          ))}
                      </select>
                      {formVaild.property_id && (
                        <span style={{ color: "red" }}>
                          {formVaild.property_id}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label htmlFor="exampleFormControlLastName">
                        {strings.csv}
                        <span className="required-field"></span>{"  "}
                        (<a onClick={() => { dispatch(downloadCSVFIle()) }} style={{ color: "#4466f2", cursor: "pointer" }}>{strings.downloadCsvFile}</a>)
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept=".csv,.CSV"
                        onChange={handleChange}
                      />
                      {formVaild.image && (
                        <span style={{ color: "red" }}>{formVaild.image}</span>
                      )}
                      {formVaild.validMedia && (
                        <span style={{ color: "red" }}>
                          {formVaild.validMedia}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-footer d-flex justify-content-end">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleUpdate()}
                      >
                        {strings.upload}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadCsv;
